(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePriceDialogController', InvoicePriceDialogController);

    InvoicePriceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoicePrice', 'Invoice', 'Fixation', 'Lot'];

    function InvoicePriceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoicePrice, Invoice, Fixation, Lot) {
        var vm = this;

        vm.invoicePrice = entity;
        vm.clear = clear;
        vm.save = save;
        vm.invoices = Invoice.query();
        vm.fixations = Fixation.query();
        vm.lots = Lot.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoicePrice.id !== null) {
                InvoicePrice.update(vm.invoicePrice, onSaveSuccess, onSaveError);
            } else {
                InvoicePrice.save(vm.invoicePrice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:invoicePriceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
